import { useState } from 'react';
import { useLanguage } from '@/shared/hooks/useLanguage';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ = () => {
  const { translations, isRTL } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs: FAQItem[] = [
    {
      question: translations.faqQ1,
      answer: translations.faqA1,
    },
    {
      question: translations.faqQ2,
      answer: translations.faqA2,
    },
    {
      question: translations.faqQ3,
      answer: translations.faqA3,
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-full py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-white">
          {translations.faqTitle}
        </h2>
        
        <div className="max-w-3xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-white/20 rounded-lg overflow-hidden transition-all bg-white/10 backdrop-blur-sm"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-white/20 text-white transition-colors"
                aria-expanded={openIndex === index}
              >
                <span className={`font-semibold text-lg ${isRTL ? 'text-right' : 'text-left'}`}>
                  {faq.question}
                </span>
                <svg
                  className={`w-5 h-5 transition-transform flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              
              {openIndex === index && (
                <div className="px-6 py-4 border-t border-white/20 bg-white/5 text-white/90">
                  <p className={`${isRTL ? 'text-right' : 'text-left'} leading-relaxed`}>
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;

